import { useState, useCallback } from 'react';
export function useVisibilityControl(items, getEntities) {
    const [isVisible, setIsVisible] = useState(false);
    const [itemVisibility, setItemVisibility] = useState(new Map());
    const hideAll = useCallback(() => {
        items.forEach(item => {
            const entities = getEntities(item);
            entities.forEach(entity => {
                if (entity)
                    entity.show = false;
            });
        });
        setItemVisibility(prev => {
            const newMap = new Map(prev);
            items.forEach((_, id) => newMap.set(id, false));
            return newMap;
        });
        setIsVisible(false);
    }, [items, getEntities]);
    const showAll = useCallback(() => {
        items.forEach(item => {
            const entities = getEntities(item);
            entities.forEach(entity => {
                if (entity)
                    entity.show = true;
            });
        });
        setItemVisibility(prev => {
            const newMap = new Map(prev);
            items.forEach((_, id) => newMap.set(id, true));
            return newMap;
        });
        setIsVisible(true);
    }, [items, getEntities]);
    const toggleItemVisibility = useCallback((id) => {
        var _a, _b;
        const item = items.get(id);
        if (!item)
            return;
        const entities = getEntities(item).filter(Boolean);
        if (entities.length === 0)
            return;
        const currentlyVisible = itemVisibility.has(id) ? itemVisibility.get(id) : ((_b = (_a = entities[0]) === null || _a === void 0 ? void 0 : _a.show) !== null && _b !== void 0 ? _b : false);
        const newVisible = !currentlyVisible;
        entities.forEach(entity => {
            entity.show = newVisible;
        });
        setItemVisibility(prev => {
            const newMap = new Map(prev);
            newMap.set(id, newVisible);
            return newMap;
        });
    }, [items, getEntities, itemVisibility]);
    const isItemVisible = useCallback((id) => {
        if (itemVisibility.has(id)) {
            return itemVisibility.get(id);
        }
        const item = items.get(id);
        if (item) {
            const entities = getEntities(item);
            const firstEntity = entities.find(e => e !== undefined);
            if (firstEntity)
                return firstEntity.show;
        }
        return false;
    }, [itemVisibility, items, getEntities]);
    const hideEntities = useCallback((item) => {
        const entities = getEntities(item);
        entities.forEach(entity => {
            if (entity)
                entity.show = false;
        });
    }, [getEntities]);
    return {
        isVisible,
        setIsVisible,
        hideAll,
        showAll,
        toggleItemVisibility,
        isItemVisible,
        hideEntities
    };
}
